<div class="switch" [class.disabled]="disabled()" [class.readonly]="readonly() && !disabled()">
  @for(option of options(); track option.value) {
    <button
      class="option"
      [class.active]="isActive(option.value)"
      [disabled]="disabled()"
      [tabindex]="readonly() ? '-1' : '0'"
      (click)="selectOption(option.value)"
      type="button"
    >
      {{ option.label | translate }}
    </button>
  }
</div>
